import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const CheckBox = ({ children, className, testId, value, ...rest }) => (
  <label data-testid={testId} className={classNames('main-checkbox', className)}>
    <input
      checked={value}
      {...rest}
      type="checkbox"
      className="main-checkbox__input"
    />
    <span className="main-checkbox__icon mr-10" />

    <span className="main-checkbox__text">{children}</span>
  </label>
);

CheckBox.propTypes = {
  children: PropTypes.node.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool
  ]),

  className: PropTypes.string,
  testId: PropTypes.string
};

CheckBox.defaultProps = {
  className: ''
};

export default CheckBox;
